import { trackFragmentIdentifierClicks } from './trackers/track-fragment-identifier-clicks.ts';

trackFragmentIdentifierClicks();
